import BaseService from '@core/class/BaseService';
import { IPagination } from '../../Product/interfaces';
class StockServices extends BaseService {
  public fetchData = ({
    productName,
    page,
    fieldSearch,
    sort,
    fromDt,
    toDt
  }: IPagination) => {
    let data = [...Array(10)].map((item, index) => ({
      ...item,
      ...{
        productName: ['', 't-Shirt', 'Jean', 'Kaky', 'Hat'][
          Math.ceil(Math.random() * 3)
        ],
        quantity: [1, 1, 3, 5, 6, 8][Math.ceil(Math.random() * 5)],
        SSKU: 33012 + Number(index),
        centerName: ['', 'Old', 'New'][Math.ceil(Math.random() * 2)],
        UpdateDate:
          new Date().getTime() +
          [0, 1000, 10000, 3000][Math.ceil(Math.random() * 3)]
      }
    }));
    return { data: data };
  };

  public getPaging = ({
    productName,
    page,
    fieldSearch,
    sort,
    fromDt,
    toDt,
    limit = 10
  }: IPagination) => {
    let url =
      'api/v1/seller/warehouses/warehouse-imported' + `?page=${page}&limit=${limit}`;
    url =
      productName !== '' &&
      productName !== null &&
      fieldSearch !== '' &&
      !!fieldSearch
        ? (url += `&filter.${fieldSearch}=${productName}`)
        : url;
    url = sort
      ? (url += `&sortBy=updated_at:DESC`)
      : (url += '&sortBy=updated_at:ASC');
    url = fromDt ? (url += `&filter.from=${fromDt}`) : url;
    url = toDt ? (url += `&filter.to=${toDt}`) : url;
    return this.get(url);
  };

  //api export excel all of stock
  public exportExcel = ({
    fieldSearch,
    productName,
    sort,
    fromDt,
    toDt
  }: IPagination) => {
    let url = `api/v1/seller/warehouses/imported/export-all?`;
    url +=
      (!!productName && !!fieldSearch
        ? `&filter.${productName}=${fieldSearch}`
        : '') +
      (!!fromDt ? `&filter.from=${fromDt}` : '') +
      (!!toDt ? `&filter.to=${toDt}` : '') +
      (sort ? `&sortBy=updated_at:DESC` : `&sortBy=updated_at:ASC`);
    let urlUse = url.replace('?&', '?');
    return this.get(
      urlUse,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  //api export excel follow array id of stock
  public exportExcelById = (productId: number[]) => {
    let value = 'ids=';
    productId.forEach((item: number) => {
      value = value + item + ',';
    });
    return this.get(
      `api/v1/seller/warehouses/imported/export?${value.substring(
        0,
        value.length - 1
      )}`,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  //api get detail product
  public getPagingStock = ({
    productName,
    page,
    fieldSearch,
    sort,
    id,
    fromDt,
    toDt
  }: IPagination) => {
    let url =
      'api/v1/seller/products/stock' + `/${id}` + `?page=${page}&limit=10`;
    url =
      productName !== '' &&
      productName !== null &&
      fieldSearch !== '' &&
      !!fieldSearch
        ? (url += `&filter.${fieldSearch}=${productName}`)
        : url;
    url = sort
      ? (url += `&sortBy=updated_at:DESC`)
      : (url += '&sortBy=updated_at:ASC');
    url = fromDt ? (url += `&filter.from=${fromDt}`) : url;
    url = toDt ? (url += `&filter.to=${toDt}`) : url;
    return this.get(url);
  };

  public getDetailInfo = (id: number) => {
    return this.get(`api/v1/seller/warehouses/detail/${id}`);
  };

  //api export excel all of list stock
  public exportExcelAllOfListStock = ({
    fieldSearch,
    productName,
    sort,
    fromDt,
    toDt,
    numberDetail
  }: IPagination) => {
    let url = `api/v1/seller/products/list-stock/export-all/${numberDetail}?`;
    // console.log(!!productName && !!fieldSearch, productName, fieldSearch, 1000);
    url +=
      (!!productName && !!fieldSearch
        ? `&filter.${productName}=${fieldSearch}`
        : '') +
      (!!fromDt ? `&filter.from=${fromDt}` : '') +
      (!!toDt ? `&filter.from=${fromDt}` : '') +
      (sort ? `&sortBy=updated_at:DESC` : `&sortBy=updated_at:ASC`);
    let urlUse = url.replace('?&', '?');
    return this.get(
      urlUse,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  //api export excel of list stock
  public exportExcelByIdOfListStock = (
    productId: number[],
    stockId: number
  ) => {
    let value = 'ids=';
    productId.forEach((item: number) => {
      value = value + item + ',';
    });
    return this.get(
      `api/v1/seller/products/list-stock/export?${value.substring(
        0,
        value.length - 1
      )}`,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  public getPaginationOrderFake = ({
    id,
    page,
    sort
  }: {
    id: number;
    page?: number;
    sort?: boolean;
  }) => {
    let data = [...Array(5)].map((item, index) => ({
      ...item,
      ...{
        status: ['', '배송 요청', '배송 중', '배송 완료'][
          Math.ceil(Math.random() * 3)
        ],
        quantity: [1, 1, 3, 5, 6, 8][Math.ceil(Math.random() * 5)],
        no: 33012 + Number(index),
        updated_at:
          new Date().getTime() +
          [0, 1000, 10000, 3000][Math.ceil(Math.random() * 3)]
      }
    }));
    return { data: data };
  };

  public getPaginationOrder = ({
    id,
    page,
    sort
  }: {
    id: number;
    page?: number;
    sort?: boolean;
  }) => {
    let url =
      `api/v1/seller/orders/list-by-product/${id}?page=${page}&limit=5` +
      (!sort ? `&sortBy=updated_at:DESC` : `&sortBy=updated_at:ASC`);
    return this.get(url);
  };
}

export default new StockServices('/', true);
